/**
 * Пилюля Р·О — присутствие бренда в каналах (§4.6, §5.2).
 *
 * Буква активного канала — тёмная залитая; второй канал — серая обводка
 * (бренд там есть) или серая зачёркнутая (бренда там нет). Клик по обводке
 * переключает канал с сохранением позиции, клик по зачёркнутой — «Добавить
 * в Опт», то есть обычная правка в черновик.
 */
import type { ChannelCode } from '@shared/types.ts'
import { Tooltip } from '../../../../components/index.js'
import { tableTexts as t } from '../../texts.table.js'
import type { CellProps } from './CellBox.js'

const LETTER: Record<ChannelCode, string> = { retail: 'Р', b2b: 'О' }
const NAME: Record<ChannelCode, string> = { retail: 'Розницу', b2b: 'Опт' }

export function PresenceCell({ row, ctx, actions, readOnly }: CellProps) {
  if (row.kind !== 'brand') return null
  const brand = row.brand
  const order: ChannelCode[] = ['retail', 'b2b']

  return (
    <span className="cell__presence">
      {order.map((channel, index) => {
        const active = channel === ctx.channel
        const present = brand.channels[channel] !== undefined
        const classes = ['cell__letter']
        if (active) classes.push('cell__letter--active')
        else if (present) classes.push('cell__letter--other', 'cell__letter--button')
        else classes.push('cell__letter--absent', 'cell__letter--button')

        const label = active
          ? `${brand.name} · ${NAME[channel]}`
          : present
            ? t.hint.channelLetterPresent(NAME[channel])
            : t.hint.channelLetterAbsent(NAME[channel])

        const letter = active ? LETTER[channel] : LETTER[channel].toLowerCase()

        const node = active ? (
          <span key={channel} className={classes.join(' ')} aria-label={label}>{letter}</span>
        ) : (
          <Tooltip key={channel} content={label}>
            <button
              type="button"
              className={classes.join(' ')}
              aria-label={label}
              disabled={!present && readOnly}
              onMouseDown={(event) => event.stopPropagation()}
              onClick={(event) => {
                event.stopPropagation()
                if (present) actions.switchChannel(channel)
                else actions.addToChannel(channel)
              }}
            >
              {letter}
            </button>
          </Tooltip>
        )

        return index === 0
          ? node
          : [<span key={`${channel}-sep`} className="cell__sep" aria-hidden="true">·</span>, node]
      })}
    </span>
  )
}
